import React from 'react';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Link, withRouter } from "react-router-dom";
import CustomLink from "../common/CustomLink";
import { Badge, CircleButton, Typography } from "../ecosystem";

const ResourceSubHeading = ({
    as,
    count,
    customLink,
    disabled,
    heading,
    linkHeading = true,
    logName,
    target,
    url
}) => {

    const handleTileClick = (tileName) => {
        logUI(`MBHWeb.UI.ResourceTile.${tileName}.Clicked`, new Date(), Tools.getURLPath());
    }

    const logTileName = logName ? logName : heading.replace(/\s+/g, '');

    const resourceSubHeadingClasses = [
        `resource-sub-heading-container`,
        `${disabled ? 'resource-sub-heading-container--disabled' : ''}`,
    ].join(' ');

    const headingProps = {
        className: "resource-sub-heading__link",
        onClick: () => { handleTileClick(logTileName) },
        target: target ? target : null
    };

    const linkAs = as ? as
        : (customLink
            ? <CustomLink linkProps={{ ...headingProps, ...customLink}}></CustomLink>
            : <Link to={{ pathname: url }}></Link>);
    const headingAs = (disabled || !linkHeading) ? <div></div> : linkAs;

    const element = React.cloneElement(
        headingAs,
        {...headingProps},
        <>
            <Typography
                type="heading-02"
                tag="div"
                bold
                color={disabled ? "$color-secondary-a3" : "$color-primary-a2"}>
                {heading}
            </Typography>
            {linkHeading && <>
                {(count && count > 0)
                    ? <Badge show="true" count={count} disabled={disabled} ></Badge>
                    : <CircleButton icon="arrow" colorStyle="float" as={'div'} disabled={disabled} />}
            </>}
        </>
    );

    return (<div className={resourceSubHeadingClasses}>
        {element}
    </div>);
}

export default withRouter(ResourceSubHeading);
